import { ID } from "common/entities/IEntity";
import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import { Form, Input, InputType } from "decorator-form";
import RemoteCondition from "./entities/RemoteCondition";

const tagsSelect = EntityMultiSelect.registered(RemoteCondition, {});

@Form ({title: "Condition Progress Config"})
export default class ConditionProgressConfig {

	@Input({type: tagsSelect, title: "Filter To Tags"})
	public conditionIds: ID[];

}



// WEBPACK FOOTER //
// ./src/panels/conditionProgress/ConditionProgressConfig.ts